import { render } from "./ResendDispatcher.vue?vue&type=template&id=fbad985c&scoped=true&ts=true"
import script from "./ResendDispatcher.vue?vue&type=script&lang=ts"
export * from "./ResendDispatcher.vue?vue&type=script&lang=ts"

import "./ResendDispatcher.vue?vue&type=style&index=0&id=fbad985c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbad985c"]])

export default __exports__